var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-4 pb-2 md:mr-10 mr-2",staticStyle:{"max-width":"160px"}},[_c('img',{attrs:{"src":"/img/assets/uni/images/long-uniti-logo2.png"}})])
}]

export { render, staticRenderFns }